import { tns } from "tiny-slider";

const sliders = Array.from(document.querySelectorAll(".extra-links-wrapper"));

function setup(el) {
    const container = el.querySelector('.extra-links-container')
    const controlsContainer = el.querySelector('.extra-links-controls')

    tns({
        container,
        controlsContainer,
        nav: false,
        items: 1,
        gutter: 22,
        responsive: {
            480: {
                items: 2,
            },
            640: {
                items: 3,
            },
            768: {
                items: 3,
            },
            1024: {
                items: 4,
            },
        }
    })
}

function init() {
    if (!sliders) return;

    sliders.forEach(setup)
}

init();
